"use client";

import { useState, ReactNode } from "react";
import { Typography } from "../typography";
import { cn } from "@drpcrd/utils/shared";

type Props = {
  onToggle: (checked: boolean) => void;
  disabled?: boolean;
  label?: string | ReactNode;
  initialChecked?: boolean;
};

/**
 * Custom toggle component  with specific layout styling
 */
export const Toggle = ({
  onToggle,
  disabled = false,
  label,
  initialChecked = false,
}: Props) => {
  const [isChecked, setIsChecked] = useState(initialChecked);

  const handleToggle = () => {
    if (disabled) {
      return;
    }

    setIsChecked(!isChecked);
    onToggle(!isChecked);
  };

  return (
    <div
      className={cn(
        "flex h-[20px] w-full items-center gap-[12px]",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
      )}
      onClick={handleToggle}
    >
      {/* Toggle Switch */}
      <div
        className={cn(
          "relative h-[20px] w-[36px] shrink-0 rounded-[10px] transition-colors duration-200 ease-linear",
          isChecked ? "bg-primary" : "bg-neutral-800",
        )}
      >
        {/* Toggle Circle */}
        <div
          className={cn(
            "absolute top-[2px] h-[16px] w-[16px] rounded-full bg-white transition-[left] duration-200 ease-linear",
            isChecked ? "left-[18px]" : "left-[2px]",
          )}
        />
      </div>

      {/* Label Text */}
      {label &&
        (typeof label === "string" ? <Typography>{label}</Typography> : label)}
    </div>
  );
};
